"use client";

import { MapPin, Phone, Mail, Linkedin, Twitter, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-2">
        {[...Array(3)].map((_, i) => <div key={i} className="h-5 w-24 bg-muted/20 rounded-md animate-pulse" />)}
      </div>;
  }
  return <nav className="space-y-2">
      {menuItems.map(item => <Link key={item.id} to={item.url || "#"} className="block text-muted-foreground hover:text-primary transition-colors text-sm font-default">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const services = [{
    label: "CA Teaching Credential",
    href: "/MasterTeacherPage"
  }, {
    label: "AZ Teaching Certificate",
    href: "/MasterTeacherPage"
  }, {
    label: "National Board Certification",
    href: "/MasterTeacherPage"
  }, {
    label: "TESOL/TESL Certification",
    href: "/MasterTeacherPage"
  }, {
    label: "UC Berkeley Alumnus",
    href: "/MasterTeacherPage"
  }];
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <footer data-section-id="264733" id="footer" className="dark bg-background text-foreground border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          <div className="space-y-4">
             <h3 className="font-default font-semibold text-foreground mb-4 text-lg">Math with Mr. Cottone, LLC</h3>
            
            <p className="text-muted-foreground text-sm leading-relaxed font-default">Building math confidence through personalized, high-impact virtual tutoring led by a Master Teacher.</p>
          </div>

          <div>
            <h3 className="font-default font-semibold text-foreground mb-4 text-lg">Academic Navigation</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-default font-semibold text-foreground mb-4 text-lg">Professional Credentials</h3>
            <nav className="space-y-2">
              {services.map((service, index) => <Link key={index} to={service.href} className="block text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                  {service.label}
                </Link>)}
            </nav>
          </div>

          <div className="space-y-4">
            <h3 className="font-default font-semibold text-foreground text-lg">Connect with Mr. Cottone</h3>
            <div className="space-y-3 text-sm text-muted-foreground font-default">
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="#" className="hover:text-primary transition-colors">
                  Schedule a Consultation
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="mailto:robert@mathwithmrcottone.com" className="hover:text-primary transition-colors">
                  robert@mathwithmrcottone.com
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>Virtual Classrooms <br />Serving CA, AZ &amp; Beyond</span>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              {socialLinks.map((social, index) => <Link key={index} to={social.href} className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-secondary/10 text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all shadow-sm" aria-label={social.label}>
                  <social.icon className="w-4 h-4" />
                </Link>)}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-border/50">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-sm text-center md:text-left font-default">
            © 2026 Math with Mr. Cottone, LLC Math Tutoring. 17 Years of Educational Excellence.
          </p>
          <div className="flex items-center gap-6 text-muted-foreground text-sm font-default">
            <Link to="/PrivacyPolicyPage" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Sitemap
            </Link>
          </div>
          <p className="text-muted-foreground text-sm text-center md:text-left font-default">Math with Mr. Cottone, LLC is an independent educational service. AP®, Advanced Placement®, PSAT®, and&nbsp; SAT® are registered trademarks of the College Board, which is not affiliated with, does not sponsor, and does not endorse Math with Mr. Cottone, LLC, this website, or its services. ACT® is a registered trademark of ACT, Inc., which is not affiliated with, does not sponsor, and does not endorse Math with Mr. Cottone, LLC, this website, or its services. ALEKS® is a registered trademark of McGraw Hill, which is not affiliated with, does not sponsor, and does not endorse Math with Mr. Cottone, LLC, this website, or its services.</p>
        </div>
      </div>
    </footer>;
}